import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/wave.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/download.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/player.svg';
export default {
  name: 'ProductMedia',
  props: {
    dangerousProduct: {
      type: String,
      default: ''
    },
    dangerousProductTranslated: {
      type: String,
      default: ''
    },
    specificityLogo: {
      type: Object || null,
      required: true
    }
  },
  data: function data() {
    return {
      isPlaying: false,
      imagesPath: 'https://cdn.maisonsdumonde.com/images/segmentations/'
    };
  },
  methods: {
    labels_logos: function labels_logos(labels) {
      return Object.values(labels).filter(function (label) {
        return label.description;
      });
    }
  }
};